import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'
const caracter = Yup.string().required(mensagemPadrao)

export const schemaPagamentoCartaoCredito = Yup.object().shape({
  matriculaId: caracter,
  contrato: caracter
})
